import React, { Component } from 'react';
import { Link } from "react-router-dom";


export class LatestUpdates extends Component {

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div className="someLatest">
            <h2 className="heading-2 mb-sm">Some of my latest updates</h2>

            <p>
              These are some of my latest updates to some of the projects I have
              done. Some of the updates may be minor updates while others could
              complete redesigns
            </p>
          </div>

          <div className="latestUpdates">

            
          <div className="item">
              <div className="overlay"></div>
              <img className="cardbgimg" src="assets/img/sole.jpg" alt="" />

              <div className="item-badge">
                <img src="assets/img/badge.png" alt="" />
              </div>

              <div className="img-overlay">
                <h3 className="heading-3">Social Sole</h3>
                <p>
                I've implemented some significant updates to SocialSole. Here's some of what's new. Complete Site Redesign, SocialSole now sports a modern and sleek design, enhancing the overall user experience. Realtime Search Overlay: Users can now perform searches in real-time through a dynamic overlay, providing quick and relevant results. Custom Lists, Users can now create and manage custom lists, allowing them to save articles, posts, and sneakers for future reference.
                </p>
              </div>

              <Link to="/sole" className="readmore">
                READ MORE
              </Link>
            </div>

            <div className="item">
              <div className="overlay"></div>
              <img className="cardbgimg" src="assets/img/massnow.jpg" alt="" />

              <div className="item-badge">
                <img src="assets/img/badge-massnow.png" alt="" />
              </div>

              <div className="img-overlay">
                <h3 className="heading-3">MassNow News Site</h3>
                <p>
                  This is a new completed project, a fictional news site similar to Masslive.com.
                  It has full CRUD capabilities, and role based authentication.

                </p>
              </div>

              <Link to="/massnow" className="readmore">
                READ MORE
              </Link>
            </div>

            <div className="item">
              <div className="overlay"></div>
              <img className="cardbgimg" src="assets/img/cuisener.jpg" alt="" />

              <div className="item-badge">
                <img src="assets/img/badge-cusiener.png" alt="" />
              </div>

              <div className="img-overlay">
                <h3 className="heading-3">The Social Cuisiner</h3>
                <p>
                  This project has since undergone a major overhaul as far as
                  design and functionality goes. The previous design used
                  Bootstrap for the css, however that has now been taken out in
                  favor of using a combination of Css Grid, and Flex-box.
                </p>
              </div>

              <Link to="/social" className="readmore">
                READ MORE
              </Link>
            </div>


            <div className="item">
              <div className="overlay"></div>

              <img className="cardbgimg" src="assets/img/practice.jpg" alt="" />

              <div className="item-badge">
                <img src="assets/img/badge-practice.png" alt="" />
              </div>

              <div className="img-overlay">
                <h3 className="heading-3">The Practice of Arthur E. Cash</h3>
                <p>
                  I recently did a complete redesign to the site to give it a
                  cleaner modern look and feel.
                </p>
              </div>

              <Link to="/arthurcash" className="readmore">
                READ MORE
              </Link>
            </div>

            <div className="item">
              <div className="overlay"></div>
              <img
                className="cardbgimg"
                src="assets/img/postmaster.jpg"
                alt=""
              />

              <div className="item-badge">
                <img src="assets/img/badge-postmaster.png" alt="" />
              </div>

              <div className="img-overlay">
                <h3 className="heading-3">The Postmaster</h3>
                <p>
                  Completely redesigned the look of the site using CSS Grid and
                  Flexbox, to give the site a more modern look. In addition
                  added the ability to delete surveys. And added the ability to
                  add a custom reply to field when creating surveys.
                </p>
              </div>

              <Link to="/postmaster" className="readmore">
                READ MORE{" "}
              </Link>
            </div>

            {/* <div className="item">

                <div className="overlay"></div>

                <img className="cardbgimg" src="assets/img/blueleaf.jpg" alt=""/>

                <div className="item-badge">
                    <img src="assets/img/badge-blueuniv.png" alt=""/>
                </div>

                <div className="img-overlay">

                  <h3 className="heading-3">Blueleaf University</h3>

                  <p>
                  Added a JQuery slider to the front end hero section. In addition to users have the ability to choose how many slides will display in the slider as well as the abitlity to choose the background image for each slide, and whatever content they want on each slide. Also added an Ajax search bar for a better user experience 
                  </p>

                </div>

                <Link to="/blueleaf" className="readmore">READ MORE</Link>

              </div>
              */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default LatestUpdates
